import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6a6825e2")
const _hoisted_1 = {
  id: "toolbar",
  class: "main-toolbar no-printable"
}
const _hoisted_2 = { class: "toolbar-container" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolbarButton = _resolveComponent("ToolbarButton")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_font_awesome_layers = _resolveComponent("font-awesome-layers")!
  const _component_color_picker = _resolveComponent("color-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ToolbarButton, {
        icon: ['fas', 'file'],
        title: "Nuevo (N)",
        onClick: _ctx.newTrinket
      }, null, 8, ["onClick"]),
      _createVNode(_component_ToolbarButton, {
        icon: ['fas', 'folder'],
        title: "Abrir",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.trinketFileLoader.click()))
      }, {
        default: _withCtx(() => [
          _createElementVNode("input", {
            id: "trinketFileInput",
            type: "file",
            accept: "application/json",
            style: {"display":"none"},
            ref: "trinketFileLoader",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadTrinket && _ctx.loadTrinket(...args)))
          }, null, 544)
        ]),
        _: 1
      }),
      _createVNode(_component_ToolbarButton, {
        icon: ['fas', 'save'],
        title: "Guardar (Ctrl + S)",
        onClick: _ctx.saveTrinket
      }, null, 8, ["onClick"]),
      _createVNode(_component_ToolbarButton, {
        icon: ['fas', 'download'],
        title: "Exportar (Ctrl + Shift + S)",
        onClick: _ctx.exportTrinket
      }, null, 8, ["onClick"]),
      _createVNode(_component_ToolbarButton, {
        icon: ['fas', 'print'],
        title: "Imprimir (Ctrl + P)",
        onClick: _ctx.print
      }, null, 8, ["onClick"]),
      _createVNode(_component_ToolbarButton, {
        icon: ['fas', 'eye-dropper'],
        selected: _ctx.selectedTool === _ctx.Tools.PICKER,
        title: "Cuentagotas (P)",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectTool(_ctx.Tools.PICKER)))
      }, null, 8, ["selected"]),
      _createVNode(_component_ToolbarButton, {
        icon: ['fas', 'fill'],
        selected: _ctx.selectedTool === _ctx.Tools.FILLER,
        title: "Relleno (F)",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectTool(_ctx.Tools.FILLER)))
      }, null, 8, ["selected"]),
      _createVNode(_component_ToolbarButton, {
        icon: ['far', 'circle'],
        selected: _ctx.selectedTool === _ctx.Tools.BORDER,
        title: "Borde (B)",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectTool(_ctx.Tools.BORDER)))
      }, null, 8, ["selected"]),
      _createVNode(_component_ToolbarButton, {
        icon: ['fas', 'minus'],
        selected: _ctx.selectedTool === _ctx.Tools.LINE,
        title: "Línea (L)",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectTool(_ctx.Tools.LINE)))
      }, null, 8, ["selected"]),
      _createVNode(_component_ToolbarButton, {
        icon: ['fas', 'font'],
        selected: _ctx.selectedTool === _ctx.Tools.TEXT,
        title: "Texto (T)",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectTool(_ctx.Tools.TEXT)))
      }, null, 8, ["selected"]),
      _createVNode(_component_ToolbarButton, {
        selected: _ctx.selectedTool === _ctx.Tools.ERASER,
        title: "Borrar punto (E)",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectTool(_ctx.Tools.ERASER)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_layers, null, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'eraser'] }),
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'circle'],
                transform: "shrink-6 up-11 left-11"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["selected"]),
      _createVNode(_component_ToolbarButton, {
        selected: _ctx.selectedTool === _ctx.Tools.LINE_ERASER,
        title: "Borrar línea (Ctrl + E)",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectTool(_ctx.Tools.LINE_ERASER)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_layers, null, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'eraser'] }),
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'minus'],
                transform: "shrink-6 up-11 left-11"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["selected"]),
      _createVNode(_component_ToolbarButton, {
        selected: _ctx.openPicker === 'fill',
        class: "button-picker",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openPicker = 'fill'))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_layers, null, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'square'],
                style: _normalizeStyle({ color: _ctx.fillColor })
              }, null, 8, ["style"]),
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'fill'],
                transform: "shrink-6 up-11 left-11"
              })
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.openPicker === 'fill')
                ? (_openBlock(), _createBlock(_component_color_picker, {
                    key: 0,
                    color: _ctx.fillColor,
                    colorsDefault: _ctx.palette,
                    "show-alpha": false,
                    "sucker-hide": true,
                    class: "color-picker",
                    theme: "light",
                    onChangeColor: _cache[9] || (_cache[9] = ($event: any) => (_ctx.fillColor = $event.hex))
                  }, null, 8, ["color", "colorsDefault"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["selected"]),
      _createVNode(_component_ToolbarButton, {
        selected: _ctx.openPicker === 'stroke',
        class: "button-picker",
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openPicker = 'stroke'))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_layers, null, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'square'],
                style: _normalizeStyle({ color: _ctx.strokeColor })
              }, null, 8, ["style"]),
              _createVNode(_component_font_awesome_icon, {
                icon: ['far', 'circle'],
                transform: "shrink-6 up-11 left-11"
              })
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.openPicker === 'stroke')
                ? (_openBlock(), _createBlock(_component_color_picker, {
                    key: 0,
                    color: _ctx.strokeColor,
                    colorsDefault: _ctx.palette,
                    "show-alpha": false,
                    "sucker-hide": true,
                    class: "color-picker",
                    theme: "light",
                    onChangeColor: _cache[11] || (_cache[11] = ($event: any) => (_ctx.strokeColor = $event.hex))
                  }, null, 8, ["color", "colorsDefault"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["selected"]),
      _createVNode(_component_ToolbarButton, {
        selected: _ctx.openPicker === 'lineStroke',
        class: "button-picker",
        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.openPicker = 'lineStroke'))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_layers, null, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'square'],
                style: _normalizeStyle({ color: _ctx.lineStrokeColor })
              }, null, 8, ["style"]),
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'minus'],
                transform: "shrink-6 up-11 left-11"
              })
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.openPicker === 'lineStroke')
                ? (_openBlock(), _createBlock(_component_color_picker, {
                    key: 0,
                    color: _ctx.lineStrokeColor,
                    colorsDefault: _ctx.palette,
                    "show-alpha": false,
                    "sucker-hide": true,
                    class: "color-picker",
                    theme: "light",
                    onChangeColor: _cache[13] || (_cache[13] = ($event: any) => (_ctx.lineStrokeColor = $event.hex))
                  }, null, 8, ["color", "colorsDefault"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["selected"]),
      _createVNode(_component_ToolbarButton, {
        icon: ['fas', 'cog'],
        title: "Opciones",
        onClick: _ctx.openOptions
      }, null, 8, ["onClick"])
    ])
  ]))
}